module.exports = __webpack_public_path__ + "static/media/event_search.925474fd.png";